import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { PageSideNavigationGroup } from '@app/shared/models/nav-item.model';
import { FeatureFlagService } from '../services/feature-flag.service';

@Injectable()
export class MenuResolverService {
    constructor(private featureFlagService: FeatureFlagService) {}

    async resolve(route: ActivatedRouteSnapshot): Promise<PageSideNavigationGroup[]> {
        const groups: PageSideNavigationGroup[] = route.data['menuItems'];
        const permissionsLevel = route.data['featureFlagPermissionLevel'];
        const featureFlags = await this.featureFlagService.getAllFeaturesFlags(permissionsLevel);
        const featureFlagKeys: string[] = featureFlags.map((feature) => feature.feature);

        return groups
            .map((group: PageSideNavigationGroup) => {
                return {
                    ...group,
                    items: group.items
                        .filter((item) => {
                            return featureFlagKeys.includes(item.featureFlagKey)
                                ? featureFlags.find((flag) => flag.feature === item.featureFlagKey)
                                      .value
                                : true;
                        })
                        .map((item) => ({
                            ...item,
                            active: false,
                        })),
                };
            })
            .filter((group) => !!group.items.length);
    }
}
